import PropTypes from 'prop-types'
import { Box, Button, Dialog, Heading, Icon, Text } from '@redriverpress/system'

export default function SubscribeNowDialog({ subtitle, open, onOpenChange }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.StyledContent
          onPointerDownOutside={e => {
            e.preventDefault()
            onOpenChange(false)
          }}
        >
          <Dialog.StyledTitle>
            <Heading as='h6' mb={0}>
              Subscribe Now
            </Heading>
          </Dialog.StyledTitle>
          {subtitle && <Text mb={[3, null, 4]}>{subtitle}</Text>}
          <Box
            display='flex'
            flexDirection={['column', null, 'row']}
            justifyContent='center'
          >
            <Button
              secondary
              as='a'
              href={`/sign_in?return_to=${window.location.href}`}
              small
              mr={[null, null, 2]}
              mb={[2, null, 0]}
            >
              <Icon icon='sign-in' pr={2} />
              Log In
            </Button>
            <Button as='a' href='/pricing' small>
              <Icon icon='plus' pr={2} />
              Sign Up
            </Button>
          </Box>
        </Dialog.StyledContent>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

SubscribeNowDialog.propTypes = {
  subtitle: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
}
